import React, { Component } from 'react';
import WordBlocking from './WordBlocking.js';

/**
* @memberof Blocking
* @extends Component
* @classdesc (Component) This component renders the words of a line, managing
* the props of the child component < WordBlocking/>
* @prop {number} lineNum - (prop) Line number for tracking
* @prop {array} words - (prop) array of each individual word of the line
* @prop {object} actions - (prop) Group of callbacks to manage state and BlockID
* @prop {object} blocking - (state) state associated with blocking
* @prop {object} entries - (state) previously submitted blocks
*/
class LineBlocking extends Component {

  /**
  * Renders WordBlocking component with
  * correct blockID, props, and callbacks
  * checks if word is hovered or marked
  * @returns {object} < LineBlocking />
  */
  getWords(){
    const {lineNum, actions, blockState, getBlockID} = this.props;
    const hoverIndex = blockState.hover.line === lineNum ? blockState.hover.word : null;
    const markedWords = blockState.markedWords[lineNum] ? blockState.markedWords[lineNum] : null;

    /**
    * Maps over words checking the index
    * against the marked and hovered this.state and
    * passes appropriate props if marked or hovered.
    * @member Blocking.LineBlocking#words
    *
    */
    const words = this.props.words.map(function(word, index){
      index = index +1;
      //calcuate whether word is marked
      let marked = false, hover = false;
          hover = hoverIndex === index ? true : false;

      if(markedWords){
        marked = markedWords.indexOf(index) !== -1 ? true : false;
      }

      const ele = new Array(
        <WordBlocking
          key={word.string + index}
          index = {{word: index, line: lineNum}}
          actions = {actions}
          word = {word}
          blockID = {getBlockID()}
          marked = {marked}
          hover = {hover}
        />
      );

      if(marked || hover)
        actions.nextBlock();

      return ele;
    });
    return words;
  }

  /** Renders < WordBlocking/> in a < li> tag */
  render(){
    const words = this.getWords();
    return (
      <li className = 'line'>
        {words}
      </li>
    );
  }
}

export default LineBlocking;



// WEBPACK FOOTER //
// ./src/components/Blocking/LineBlocking.js